export default __webpack_public_path__ + "static/media/loading-dog.cec6f0d4.gif";